import { functions } from '../../../config/firebase'
import { getCallableErrorMessage } from '../../ProductsSyncMenu/syncDateUtils'

const upsertAmeCampaign = async (payload) => {
  try {
    const callable = functions.httpsCallable('upsertAmeCampaign')
    const result = await callable(payload)
    return {
      ok: true,
      campaign: result?.data?.campaign || null,
    }
  } catch (error) {
    console.error('[upsertAmeCampaign] failed:', error)
    const code = typeof error?.code === 'string' ? error.code.replace('functions/', '') : ''
    if (code === 'not-found') {
      return {
        ok: false,
        message: 'upsertAmeCampaign is not deployed. Run: firebase deploy --only functions:upsertAmeCampaign',
      }
    }
    const details =
      typeof error?.details === 'string'
        ? error.details
        : error?.details && typeof error.details === 'object' && typeof error.details.message === 'string'
          ? error.details.message
          : ''
    const raw = [code, error?.message, details].filter(Boolean).join(' — ')
    return {
      ok: false,
      message: raw || getCallableErrorMessage(error),
    }
  }
}

export default upsertAmeCampaign
